import { render } from "./CreateGroupSurveyDates.vue?vue&type=template&id=0b01dd20&scoped=true"
import script from "./CreateGroupSurveyDates.vue?vue&type=script&lang=js"
export * from "./CreateGroupSurveyDates.vue?vue&type=script&lang=js"

import "./CreateGroupSurveyDates.vue?vue&type=style&index=0&id=0b01dd20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b01dd20"]])

export default __exports__